import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';
import _Textarea from 'react-textarea-autosize';
import { Snackbar} from 'rmwc';
import {Slider} from 'rmwc';
import * as styles from '../../styles';
import {request} from '../../containers/actions';

const Textarea = new Radium(_Textarea);

//@Radium
export default class CommentForm extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static defaultProps = {
        refresh: _.identity,
        placeholder: '',
        bodyPreprocessor: _.identity,
        style: {box: {}},
        submitMessage: window.gettext('Your message has been submitted successfully!'),
    }

    state = {
        body: '',
        rates: _.mapValues(_.mapKeys(this.props.rates, _.identity), _.constant(5)),
        sent: false,
    }

    async submit() {
        await this.context.store.dispatch(request({
            path: '/comment/',
            method: 'POST',
            body: {
                body: this.props.bodyPreprocessor(this.state.body.replace(/\n/g, '<br>')),
                target: this.props.target,
                rates: _.map(this.state.rates, (value, key) => ({value, target: ['comment', null, key]})),
            },
        }));
        this.setState({body: '', sent: true});
        this.props.refresh();
    }

    render() {
        const generatedStyles = _.isFunction(this.props.style) ? this.props.style(this.props.data) : this.props.style;
        return <div style={{display: 'inline-block', width: '100%'}}>
            <Snackbar
                show={this.props.submitMessage && this.state.sent}
                onClose={() => this.setState({sent: false})}
                message={this.props.submitMessage}
            />
            {this.props.rates.length > 0
                ? <div
                    style={{
                        width: this.props.ratesWidth,
                        float: 'right',
                        paddingLeft: '.5em',
                    }}>
                    {_.map(
                        this.props.rates,
                        (text, index) => <span key={index}>
                            <div style={{color: '#8a8a8a', marginTop: '-.5em', marginBottom: '-1em'}}>
                                {text}
                            </div>
                            {this.state.body
                                ? <Slider
                                    key={index + ':controller'}
                                    min={0}
                                    max={5}
                                    step={1}
                                    discrete
                                    displayMarkers
                                    value={this.state.rates[text]}
                                    onChange={({target: {value}}) => this.setState(update(this.state, {rates: {[text]: {$set: value}}}))}
                                />
                                : this.props.averageRates[text]
                                    ? <Slider
                                        key={index + ':display'}
                                        min={0}
                                        max={5}
                                        step={0}
                                        disabled
                                        value={this.props.averageRates[text]}
                                        theme='orange'
                                    />
                                    : <Slider
                                        key={index + ':display'}
                                        min={0}
                                        max={5}
                                        step={0}
                                        disabled
                                        value={0}
                                        color={styles.rateColor}
                                    />
                            }
                        </span>,
                    )}
                </div>
                : null
            }
            <Textarea
                value={this.state.body}
                placeholder={this.props.placeholder}
                style={{
                    ...styles.field,
                    minHeight: '4em',
                    width: this.props.rates.length > 0 ? `calc(100% - 1.5em - ${this.props.ratesWidth})` : '100%',
                    maxWidth: this.props.rates.length > 0 ? `calc(100% - 1.5em - ${this.props.ratesWidth})` : '100%',
                    float: 'left',
                    ...generatedStyles.body,
                }}
                onChange={({target: {value}}) => this.setState({body: value.persian()})}>
            </Textarea>
            {this.state.body
                ? <button
                    style={{
                        ...styles.defaultButton,
                        clear: 'left',
                        float: 'left',
                        marginTop: '.5em',
                    }}
                    onClick={this.submit.bind(this)}>
                    {window.gettext('Submit')}
                </button>
                : null
            }
            <i style={{clear: 'both', display: 'block'}}></i>
        </div>;
    }
}
